<template>
  <footer
    :class="[
      isDesktop ? 'isDesktop' : '',
      isLaptop ? 'isLaptop' : '',
      isTablet ? 'isTablet' : '',
      isMobile ? 'isMobile' : '',
    ]"
    class="footer"
  >
    <div class="overlay" />
    <div class="footer-container">
      <!-- Left Section -->

      <img src="/images/logoFooter.png" alt="Logo" />
      <!-- Center Section -->
      <div class="footer-center">
        <h4>תמיכה ושירות לקוחות</h4>
        <div class="foter-center-continer">
          <div class="contact-info">
            <!-- <div @click="openWaze">
              <v-icon color="white" icon="mdi-waze"></v-icon>
              <span>קריית גת, הנשיא 1</span>
            </div>
            <span v-if="isDesktop || isLaptop">|</span> -->
            <div>
              <v-icon color="white" icon="mdi-phone"></v-icon>
              <span @click="makePhoneCall('0524661378')">052-4661378</span>
              <span @click="makePhoneCall('0506665638')">050-6665638</span>
            </div>
            <span v-if="isDesktop || isLaptop">|</span>
            <div @click="sendEmail">
              <v-icon color="white" icon="mdi-email-outline"></v-icon>
              <span>rgift494@gmail.com</span>
            </div>
          </div>
          <div class="more-contact">
            <span v-if="isDesktop || isLaptop">|</span>
            <a @click="openAnyDesk" class="footer-link"
              >השתלטות מרחוק Anydesk
            </a>
            <span>|</span>
            <a href="/policy" class="footer-link">מדיניות האתר</a>
          </div>
        </div>
      </div>

      <!-- Right Section -->
      <div class="d-flex flex-column align-center mt-4">
        <img class="dolimo-logo" :src="dolimoLogo" alt="" />
        <div class="version">v{{ config.version }}</div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
import config from "../../config";

export default {
  computed: {
    dolimoLogo() {
      return "/images/לוגו-משו-ענק-וגם-לבן.png";
    },
    config() {
      return config;
    },
    ...mapGetters({
      isMobile: "isMobile",
      isLaptop: "isLaptop",
      isTablet: "isTablet",
      isDesktop: "isDesktop",
    }),
  },
  methods: {
    openWaze() {
      // Waze deep link to the specified address
      const wazeUrl = `https://waze.com/ul?q=${encodeURIComponent(
        "קריית גת, הנשיא 1"
      )}`;
      this.openExternalLink(wazeUrl);
    },
    makePhoneCall(phoneNumber) {
      // Use tel: protocol to initiate phone call
      // window.location.href = "tel:089898766";
      window.location.href = `tel:${phoneNumber}`;
    },
    sendEmail() {
      // Use mailto: protocol to open default email client
      window.location.href = "mailto:rgift494@gmail.com";
    },
    openExternalLink(url) {
      // Open link in a new tab/window
      window.open(url, "_blank");
    },
    openAnyDesk() {
      // Check device type and open appropriate link
      if (this.isDesktop || this.isLaptop) {
        // For desktop/laptop, download the Windows executable
        window.open("https://download.anydesk.com/AnyDesk.exe", "_blank");
      } else if (this.isTablet || this.isMobile) {
        // For mobile/tablet, open respective app store
        const userAgent = navigator.userAgent.toLowerCase();

        if (/android/.test(userAgent)) {
          // Android - Google Play Store
          window.open(
            "https://play.google.com/store/apps/details?id=com.anydesk.anydeskandroid",
            "_blank"
          );
        } else if (/iphone|ipad|ipod/.test(userAgent)) {
          // iOS - App Store
          window.open(
            "https://apps.apple.com/app/anydesk/id1176131373",
            "_blank"
          );
        } else {
          // Fallback if device type can't be determined
          alert("Please visit your device's app store and search for AnyDesk");
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
// Variables
$footer-bg: #2c2c2ce2;
$text-color: #ffffff;
$hover-color: #f2f2f2;
$icon-size: 16px;

.footer {
  background-image: url("../../../public/images/footerBackGround.jpg");
  background-size: cover;
  color: $text-color;
  z-index: 0;
  background-position-y: bottom;
  position: relative;
  height: 150px;
  margin-top: 40px;
  .overlay {
    background-color: $footer-bg;
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .footer-container {
    padding: 15px 10px;
    height: 150px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 2;
    max-width: 1600px;
    margin: auto;

    .footer-center {
      display: flex;
      flex-direction: column;
      .foter-center-continer {
        display: flex;
      }
      h4 {
        font-size: 20px;
        margin-bottom: 10px;
      }

      .footer-link {
        color: $text-color;
        text-decoration: none;
        font-weight: 300;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
          color: $hover-color;
        }
      }

      span {
        margin: 0 5px;
      }
    }

    .contact-info {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 16px;
      gap: 10px;
      color: $text-color;
      font-weight: 300;
      div & :hover {
        cursor: pointer;
      }
    }
  }
  .dolimo-logo {
    max-width: 90px;
    height: auto;
  }
  .version {
    font-size: 10px;
  }
  img {
    max-width: 60px;
    height: auto;
  }
}
.isMobile.footer,
.isTablet.footer {
  height: unset !important;
}
.isMobile,
.isTablet {
  .foter-center-continer {
    flex-direction: column !important;
  }
  .footer-center {
    flex-direction: column !important;
    align-items: unset !important;
  }
  .footer-container {
    height: unset !important;
    align-items: unset !important;
    flex-direction: column !important;
    gap: 15px;
  }
  .contact-info {
    margin-bottom: 15px;
    flex-direction: column !important;
    align-items: unset !important;
  }
  .more-contact {
    flex-direction: row !important;
  }
}
</style>
